export default {
  docTitle: "Authing 开放平台",
  banner: {
    item1: {
      title: "Authing",
      title2: "开放平台",
      subtitle:
        "Authing 开放平台提供了丰富的开放接口能力以及覆盖所有主流语言的 SDK 工具包。你可通过我们提供的 API Explorer 调用并学习如何使用 API 接口，也可以通过项目实例快速上手",
      subtitleSmall:
        "Authing 开放平台提供了丰富的开放接口能力以及覆盖所有主流语言的 SDK 工具包。",
      btnName: "开发者文档",
      linkName: "API Explorer",
    },
  },
  api: {
    title: "丰富的开放能力 支持高效集成",
    desc:
      "Authing 的每个功能都提供了企业级的接口，帮助客户与 Authing 完成深度融合。",
    tabs: {
      tab1: {
        label: "管理 API",
      },
      tab2: {
        label: "认证 API",
      },
    },
    content: {
      manageUsers: "管理用户",
      manageOrg: "管理组织机构",
      manageRole: "管理角色",
      manageUserGroups: "管理用户分组",
      manageCustomField: "管理自定义字段",
      manageResourcesAuth: "管理资源与权限",
      manageDataResourcesAuth: "管理数据资源与权限",
      manageApps: "管理应用",
      manageIdentity: "管理身份源",
      manageSafeConfig: "管理安全配置",
      manageMessage: "管理消息服务",
      manageSyncCenter: "管理同步中心",
      managePipeline: "管理 PIPELINE",
      manageWebhook: "管理 WEBHOOK",
      manageLog: "获取审计日志",
      manageCost: "管理计量计费",
      messageAuth: "消息服务",
      wechatAuth: "微信相关接口",
      login: "登录",
      manageToken: "管理 TOKEN",
      logout: "登出",
      register: "注册",
      userInfo: "用户资料",
      bind: "账号绑定",
      mfa: "MFA 要素管理",
      userAbouts: "用户相关资源",
    },
  },
  manual: {
    title: "场景化的使用手册 助力快速整合身份",
    desc:
      "基于身份的不同场景，提供了相应的 Authing 使用手册，帮助客户快速完成云原生身份体系搭建。",
    b2e: {
      title: "B2E 管理员 使用手册",
      desc: "学习如何使用 Authing 为企业员工管理身份",
    },
    b2c: {
      title: "B2C 管理员 使用手册",
      desc: "学习如何使用 Authing 为 C 端用户提供更好的身份认证体验",
    },
    b2b: {
      title: "B2B 管理员 使用手册",
      desc: "学习如何使用 Authing 为 B 端用户提供更好的身份认证体验",
    },
  },
  playground: {
    title: "项目实例",
    tab: {
      b2c: "B2C 场景",
      b2e: "B2E 场景",
      b2b: "B2B 场景",
      m2m: "M2M 场景",
    },
    background: "项目背景",
    download: "敬请期待",
    try: "体验在线项目",
    check: "查看全部",
  },
  application: {
    title: "应用网络",
  },
  join: {
    title: "想要加入 Authing 合作网络？",
    desc: "你可以将应用加入到 Authing 合作网络，让千万客户快速集成访问",
    btnText: "了解更多",
  },
};
